import { render, staticRenderFns } from "./RiskManagement.vue?vue&type=template&id=0e2904d9&scoped=true"
import script from "./RiskManagement.vue?vue&type=script&lang=js"
export * from "./RiskManagement.vue?vue&type=script&lang=js"
import style0 from "./RiskManagement.vue?vue&type=style&index=0&id=0e2904d9&prod&lang=scss&scoped=true"
import style1 from "./RiskManagement.vue?vue&type=style&index=1&id=0e2904d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2904d9",
  null
  
)

export default component.exports